<section class="container-fluid px-5">
  <header class="row py-4">

    <div class="col-12 d-flex justify-content-between ">
        <div>
          <h2 class="text-left text-white mt-5">{{title}}: {{ summaryInfoDto.title }}</h2>

        </div>
        <br>
        <div class="d-flex justify-content-center align-items-center">
          <button
            class="badge rounded-pill btn btn-outline-light mt-5 d-flex align-items-center"
            [routerLink]="['/pdg/project/list/view/', idProject]"
          >
            <i
              class="fa-solid fa-right-from-bracket m-2 fs-6"
              aria-hidden="true"
            ></i>
            <span class="m-2 fs-6 ">Volver</span>
          </button>
    
         
    
      
    
        </div>
      </div>
  </header>
</section>


<section >


  <div class="container-fluid px-5">


    <br />
    <div class="row backgroundTable card">
      <div class="card-header">
        <h6 class="text-white p-2">{{title}}</h6>
      </div>
      <div class="col-12 componente-importantes componente-importantes-from-popup p-3">
        <form
          action=""
          method="post"
          (submit)="formSubmit()"
          [formGroup]="createWeeklyForm"
        >
          <div class="col-12 p-3">
            <div class="form-group">
              <div class="d-flex justify-content-start mt-4 mb-2">
                <label for="startDate" class="text-white">Avance Planificado</label>
              </div>
              <input
                type="text"
                required
                class="custom-outline-input date form-control"
                id="startDate"
                name="startDate"
                placeholder="Ingrese los datos..."
                formControlName="percent_planned"
              />
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-start mt-4 mb-2">
                <label for="startDate" class="text-white">Avance Real</label>
              </div>
              <input
                type="text"
                required
                class="custom-outline-input date form-control"
                id="startDate"
                name="startDate"
                placeholder="Ingrese los datos..."
                formControlName="percent_real"
              />
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-start mt-4 mb-2">
                <label for="endDate" class="text-white">Fecha de Evaluación</label>
              </div>
              <input
                type="date"
                required
                class="date custom-outline-input form-control"
                id="endDate"
                name="endDate"
                placeholder="Fecha de finalizacion"
                formControlName="date"
              />
            </div>
            <br />
            <div class="">
              <div class="d-flex justify-content-end">
                
                <button class="mx-2 btn btn-outline-light"> <i class="fa fa-floppy-disk" aria-hidden="true"></i>  Guardar datos</button>
              </div>
              
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
